@if (!isWritingPopup) {
  <div class="read-device-modal-comp read-device-modal-comp-transfer">
    <div id="read-default-values-popup-title" class="row signifyBoldxl custom margin-auto">{{ modalTitle }}</div>
    <div class="row custom-margin">
      <div class="col-12 found-text modal-message">
        <span class="signifyBookmd">{{ modalMessage }}</span>
      </div>
    </div>
    <div class="row button-container">
      <div class="col-1"></div>
      @if (!unsupportedFeaturesConfirmButton) {
        <button id="read-default-values-confirm-btn" (click)="confirm()" class="col-4 btn next-btn" type="button">
          Confirm
        </button>
      }
      @if (unsupportedFeaturesConfirmButton) {
        <button id="read-default-values-confirm-unsupported-btn" (click)="confirmUnsupported()" class="col-4 btn next-btn"
          type="button">Confirm
        </button>
      }
      <div class="col-1"></div>
    </div>
  </div>
}

@if (isWritingPopup && isboxconfiguredprocess) {
  <div class="read-device-modal-comp read-device-modal-comp-transfer">
    <div id="write-default-values-popup-title" class="row signifyBoldxl custom margin-auto">{{modalTitle}}</div>
    <div class="row custom-margin">
      <div class="col-12 found-text modal-message">
        <span class="signifyBookmd">{{modalMessage}}</span>
      </div>
    </div>
    <div class="row button-container">
      <div class="col-1"></div>
      @if (!unsupportedFeaturesConfirmButton) {
        <button id="write-default-values-confirm-btn" (click)="confirm()" class="col-4 btn next-btn" type="button">
          Confirm
        </button>
      }
      @if (unsupportedFeaturesConfirmButton) {
        <button id="write-default-values-confirm-unsupported-btn" (click)="confirmUnsupported()" class="col-4 btn next-btn"
          type="button">Confirm
        </button>
      }
      <div class="col-1"></div>
    </div>
  </div>
}

@if (isWritingPopup && !isboxconfiguredprocess) {
  <div class="read-device-modal-comp">
    <div id="partially-configured-device-title" class="row signifyBoldxl custom margin-auto add-margin">Proceed with partially configured device ?</div>
    <div class="row custom-margin">
      <div class="col-6 found-text signifyBookmd"><span>Configure Features</span>
      @for (feat of data; track feat) {
        <div class="child-margin">
          @if (feat.flag === 'green') {
            <span class="signifyBookmd"><img class="tick-img" src="check_circle.png" alt="Success">&nbsp;&nbsp;{{ feat.name }}</span>
          }
        </div>
      }
    </div>
    <div class="col-6 found-text signifyBookmd"><span>Ignore Features</span>
    @for (feat of data; track feat) {
      <div class="child-margin">
        @if (feat.flag === 'red') {
          <span class="signifyBookmd"><img class="tick-img"
          src="error_red.png" alt="Error">&nbsp;&nbsp;{{ feat.name }}</span>
        }
      </div>
    }
    <span class="signifyBookmd"></span>
  </div>
</div>
<div class="row btn-cont">
  <button id="partially-configured-cancel-btn" (click)="cancel()" class="col-3 btn prev-btn cancel-btn" type="button">Cancel</button>
  <div class="col-1"></div>
  <button id="partially-configured-retry-btn" (click)="retry()" class="col-3 btn prev-btn retry" type="button">Retry</button>
  <div class="col-1"></div>
  <button id="partially-configured-continue-btn" (click)="selectreader()" class="col-3 btn next-btn" type="button">Continue</button>
</div>
</div>
}
